import React from "react";
import { styled } from "@mui/material/styles";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box, IconButton } from "@mui/material";
import TextView from "../TextView";
import { colors } from "../../utils";

// Custom styled Radio component
const CustomRadio = styled(Radio)(({ theme }) => ({
  // color: colors.PrimaryPurple,
  // "&.Mui-checked": {
  //   color: colors.PrimaryPurple,
  // },
  "& .MuiSvgIcon-root": {
    fontSize: "20px",
  },
  color: colors.PrimaryPurple300,
  "&.Mui-checked": {
    color: colors.PrimaryPurple500,
  },
}));

const CustomFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  "& .MuiFormControlLabel-label": {
    color: colors.black,
    fontSize: "14px",
    fontFamily: "DM Sans, sans-serif",
  },
}));

const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    color: colors.black,
    fontSize: "12px",
    backgroundColor: colors.lightBlue,
    borderRadius: "4px",
    padding: "8px",
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: colors.lightBlue,
  },
}));

const CustomRadioButton = ({
  label,
  tooltip,
  options,
  selectedOption,
  onChange,
  orientation,
  style,
}) => {
  return (
    <Box style={{ marginBottom: 20, ...style }}>
      <FormControl component="fieldset">
        <Box display="flex" alignItems="center" style={{ marginBottom: 10 }}>
          <TextView variant="subtitle">{label}</TextView>
          {tooltip && (
            <StyledTooltip
              title={tooltip}
              placement="bottom"
              arrow
              slotProps={{
                popper: {
                  modifiers: [
                    {
                      name: "offset",
                      options: {
                        offset: [0, -5],
                      },
                    },
                  ],
                },
              }}
            >
              <IconButton size="small" style={{ marginLeft: 4 }}>
                <InfoOutlinedIcon fontSize="small" />
              </IconButton>
            </StyledTooltip>
          )}
        </Box>
        <RadioGroup
          aria-label="custom-radio-buttons"
          name="custom-radio-buttons"
          value={selectedOption}
          onChange={onChange}
          row={orientation === "horizontal"}
        >
          {options.map((option, index) => (
            <CustomFormControlLabel
              key={index}
              value={option.value}
              control={<CustomRadio />}
              label={option.label}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </Box>
  );
};

export default CustomRadioButton;
